<form #f="ngForm" (ngSubmit)="f.form.valid && createOrEditGroupDocument()">
  <!-- header -->
  <h2 *ngIf="!documents.id" mat-dialog-title mat-dialog-draggable-title> {{'service_type.add_service_type' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onBtnCancelClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <h2 *ngIf="documents.id" mat-dialog-title mat-dialog-draggable-title> {{'service_type.edit_service_type' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onBtnCancelClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <!-- end header -->
  <mat-divider></mat-divider>
  <mat-dialog-content>
    <div class="row pt-3 pb-3">
      <!-- Tên nhom-->
      <div class="col-12">
        <mat-form-field class="w-100">
          <input type="text"
            (focusout)="documents.name = documents.name == undefined ? '' : (documents.name + '').trim()" #focusInput
            matInput [placeholder]="'search_form.service_type_name' | translate" name="name"
            [(ngModel)]="documents.name" required autocomplete="off" #name="ngModel" maxlength="255">
          <button mat-button *ngIf="documents.name" type="button" matSuffix mat-icon-button aria-label="Clear"
            (click)="documents.name=''">
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="name.invalid">
            {{'validation.service_type_name_require' | translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Code -->
      <div class="col-12">
        <mat-form-field class="w-100">
          <input type="text"
                 (focusout)="documents.code = documents.code == undefined ? '' : (documents.code + '').trim()" #focusCode
                 matInput [placeholder]="'search_form.service_type_code' | translate" name="code"
                 [(ngModel)]="documents.code" required autocomplete="off" #code="ngModel" maxlength="255">
          <button mat-button *ngIf="documents.code" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="documents.code=''">
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="code.invalid">
            {{'validation.service_type_code_require' | translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Ghi chú -->
      <div class="col-12">
        <mat-form-field class="w-100">
          <textarea (focusout)="documents.note=documents.note.trim()"
                    type="text" matInput [placeholder]="'search_form.note' | translate" rows="3" name="note"
                    id="description" [(ngModel)]="documents.note">
          </textarea>
        </mat-form-field>
      </div>

      <!--Cấu hình thông báo-->
      <div class="col-12">
        <span class="modal-title">{{'search_form.notification_config' | translate}}</span>
        <mat-tab-group>
          <!-- Tiến trình xử lý-->
          <mat-tab [label]="'service_type.remind_configuration.configure_notify_sms_contract' | translate">
            <div class="reminder-to-sign"> {{'service_type.remind_configuration.set_send_sms' | translate}}
              <mat-button-toggle-group class="toggle-button">
                <mat-button-toggle [checked]="documents.isOnSMSInFlow" [value]="documents.isOnSMSInFlow" (click)="clickChangeSMSConfiguration(true)"> {{'service_type.remind_configuration.on_status' | translate}}
                </mat-button-toggle>
                <mat-button-toggle [checked]="!documents.isOnSMSInFlow" [value]="!documents.isOnSMSInFlow" (click)="clickChangeSMSConfiguration(false)"> {{'service_type.remind_configuration.off_status' | translate}}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <!--Đối tượng nhắc ký-->
            <div *ngIf="documents.isOnSMSInFlow" style="margin-top: 10px">
              {{'service_type.remind_configuration.send_sms_object' | translate}} <span>*</span>
              <div class="sign-prompt-object">
                <div>
                  <mat-checkbox color="primary" [checked]="documents.isSendCustomerInFlow" (change)="checkSendSMSCustomerInFlow()">
                    {{'search_form.customer' | translate}}
                  </mat-checkbox>
                </div>
                <div>
                  <mat-checkbox color="primary" [checked]="documents.sendSMSInternalInFlow && documents.sendSMSInternalInFlow.length > 0" (change)="checkSendSMSInternalInFlow()">
                    {{'search_form.internal' | translate}}
                  </mat-checkbox>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>{{'service_type.remind_configuration.internal_object' | translate}}</mat-label>
                    <mat-select #select multiple [value]="documents.sendSMSInternalInFlow" (valueChange)="documents.sendSMSInternalInFlow = $event">
                      <mat-option *ngFor="let internalObject of internalObjectsToSendSMS" [value]="internalObject.value" (click)="formChangingCheckSendSMSInternalInFlowEvent()" >
                        {{internalObject.viewValue  | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div style="min-height: 30px !important; padding-top: 5px">
                <mat-error *ngIf="isCheckSendSMSInFlow == false && isClickSendSMSInFlow === true">
                  {{'validation.selectObjectToSendSMS' | translate}}
                </mat-error>
              </div>
            </div>
            <div>
              <span style="font-style: italic;">
              <span style="color: red;"> {{'service_type.remind_configuration.note' | translate}} </span>
              {{'service_type.remind_configuration.note_send_sms_in_flow_1' | translate}}
              <strong>{{'service_type.remind_configuration.on_status' | translate}}</strong>
              {{'service_type.remind_configuration.note_send_sms_in_flow_2' | translate}}
              {{'service_type.remind_configuration.note_send_sms_in_flow_3' | translate}}
              {{'service_type.remind_configuration.note_send_sms_in_flow_4' | translate}}
              <strong>{{'service_type.remind_configuration.off_status' | translate}}</strong>
              {{'service_type.remind_configuration.note_send_sms_in_flow_5' | translate}}
              </span>
            </div>
          </mat-tab>

          <!-- Nhắc xử lý tự động-->
          <mat-tab [label]="'search_form.reminder_to_sign' | translate">
            <div class="reminder-to-sign"> {{'search_form.reminder_to_sign_contract' | translate}}
              <mat-button-toggle-group class="toggle-button">
                <mat-button-toggle [checked]="documents.isOnPromptToSign" id="on-button" [value]="documents.isOnPromptToSign" (click)="clickSend(true)"> {{'search_form.btn_config_notify_on' | translate}}
                </mat-button-toggle>
                <mat-button-toggle [checked]="!documents.isOnPromptToSign" [value]="!documents.isOnPromptToSign" (click)="clickSend(false)"> {{'search_form.btn_config_notify_off' | translate}}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <!--Loại cấu hình-->
            <div class="reminder-to-sign" *ngIf="documents.isOnPromptToSign">
              {{'search_form.config_type' | translate}}
              <mat-checkbox [disabled]="!documents.isOnPromptToSign" (change)="documents.isSendSmsSign = !documents.isSendSmsSign" (click)="isFormChanging = true" [checked]="documents.isSendSmsSign" color="primary">SMS
              </mat-checkbox>
              <mat-checkbox color="primary" checked="true" disabled>Email</mat-checkbox>
            </div>

            <!--Đối tượng nhắc ký-->
            <div *ngIf="documents.isOnPromptToSign" style="margin-top: 10px">
              {{'search_form.sign_prompt_object' | translate}} <span>*</span>
              <div class="sign-prompt-object">
                <div>
                  <mat-checkbox color="primary" [checked]="documents.isSendCustomerSign" (change)="checkCustomer()">
                    {{'search_form.customer' | translate}}
                  </mat-checkbox>
                </div>
                <div>
                  <mat-checkbox color="primary" [checked]="documents.sendInternalSign && documents.sendInternalSign.length > 0" (change)="checkInternal()">
                    {{'search_form.internal' | translate}}
                  </mat-checkbox>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>{{'search_form.internal_object' | translate}}</mat-label>
                    <mat-select #select multiple [value]="documents.sendInternalSign" (valueChange)="documents.sendInternalSign = $event">
                      <mat-option *ngFor="let internalObject of internalObjects" [value]="internalObject.value" (click)="formChangingCheckInternalRemindEvent()" >
                        {{internalObject.viewValue  | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div style="min-height: 30px !important; padding-top: 5px">
                <mat-error *ngIf="isCheck == false && isClick === true">
                  {{'validation.signPromptObject' | translate}}
                </mat-error>
              </div>
            </div>

            <!--Chu kỳ nhắc ký-->
            <div class="reminder-to-sign" *ngIf="documents.isOnPromptToSign">
              <mat-form-field class="w-100">
                <input type="number" min="1" maxlength="9" oninput="validity.valid||(value=''); if (Number(this.value) > 30) this.value = '30'" class="input-cycle" required matInput [placeholder]="'search_form.cycle_send_sign' | translate"
                       name="cycleSendSign" [(ngModel)]="documents.cycleSendSign" #cycleSendSign="ngModel"> {{'search_form.day_time' | translate}}
                <mat-error *ngIf="cycleSendSign.invalid">
                  {{'validation.cycle_sign_validate' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="reminder-to-sign"><span style="font-style: italic;"><span style="color: red;"> {{'search_form.note_remind_sign_contract_pre' | translate}} </span>  {{'search_form.note_remind_sign_contract' | translate}}</span>
            </div>
          </mat-tab>

          <!-- Nhắc hết hạn-->
          <mat-tab [label]="'search_form.expiration_reminder' | translate">
            <div class="reminder-to-sign"> {{'search_form.expiration_reminder_contract' | translate}}
              <mat-button-toggle-group class="toggle-button">
                <mat-button-toggle [checked]="documents.isOnNotifyExpireContract" value="on" (click)="clickSendExpire(true)">{{'search_form.btn_config_notify_on' | translate}}
                </mat-button-toggle>
                <mat-button-toggle [checked]="!documents.isOnNotifyExpireContract" value="off" (click)="clickSendExpire(false)">{{'search_form.btn_config_notify_off' | translate}}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <!-- Loại cấu hình-->
            <div class="reminder-to-sign" *ngIf="documents.isOnNotifyExpireContract">
              {{'search_form.config_type' | translate}}
              <mat-checkbox (change)="documents.isSendSmsExpireContract = !documents.isSendSmsExpireContract" [checked]="documents.isSendSmsExpireContract" color="primary" (click)="isFormChanging = true">SMS
              </mat-checkbox>
              <mat-checkbox color="primary" checked="true" disabled>Email</mat-checkbox>
            </div>

            <!--            Thời gian nhắc-->
            <div class="reminder-to-sign" *ngIf="documents.isOnNotifyExpireContract">
              <mat-form-field class="w-100">
                <input type="number" min="1" maxlength="9" oninput="validity.valid||(value=''); if (Number(this.value) > 100) this.value = '100'" class="input-cycle" matInput [placeholder]="'search_form.time_notify_before_expire' | translate"
                       name="reminderTime" [(ngModel)]="documents.timeNotifyBeforeExpire" required #timeNotify="ngModel"> {{'search_form.day_before_expire' | translate}}
                <mat-error *ngIf="timeNotify.invalid">
                  {{'validation.time_notify' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Chu kỳ nhắc hết hạn-->
            <div class="reminder-to-sign" *ngIf="documents.isOnNotifyExpireContract">
              <mat-form-field class="w-100">
                <input type="number" min="0" maxlength="9" oninput="validity.valid||(value=''); if (Number(this.value) > 30) this.value = '30'" class="input-cycle" matInput name="cycleNotify" [placeholder]="'search_form.cycle_reminder' | translate"
                       [(ngModel)]="documents.cycleNotifyExpireContract"> {{'search_form.day_time' | translate}}
                <!--                <mat-error *ngIf="cycleNotify.invalid">-->
                <!--                  {{'validation.cycle_expire' | translate}}-->
                <!--                </mat-error>-->
              </mat-form-field>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions class="mt-2" align="center">
    <button mat-stroked-button color="primary" class="mr-3 mb-1" (click)="onBtnCancelClick()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
        <ng-container>
            <button mat-raised-button type="submit" [disabled]="f.form.invalid || !isFormChanging || (!isCheck && documents.isOnPromptToSign)
                  || (!isCheckSendSMSInFlow && documents.isOnSMSInFlow)" color="primary">
        <mat-icon class="mr-0">save</mat-icon>
        <ng-container *ngIf="!documents.id; else saveButton">
          {{'button.add_service_type' | translate}}
        </ng-container>
        <ng-template #saveButton> {{'button.save' | translate}}</ng-template>
      </button>
        </ng-container>
    </mat-dialog-actions>
</form>
